module.exports = __webpack_public_path__ + "static/media/bin-light.b7557f41.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bin-light.svg
// module id = 603
// module chunks = 0